import { useCallback } from 'react';

const Sidebar = ({ setMode, mode }) => {
  const handleSetChats = useCallback(() => {
    setMode('chat');
  }, [setMode]);
  const handleSetMarket = useCallback(() => {
    setMode('market');
  }, [setMode]);
  const handleSetSettings = useCallback(() => {
    setMode('settings');
  }, [setMode]);
  const handleSetPromo = useCallback(() => {
    setMode('promocodes');
  }, [setMode]);
  const handleSetDelivery = useCallback(() => {
    setMode('delivery');
  }, [setMode]);
  return (
    <div className='sidebar'>
      <div
        onClick={handleSetChats}
        className='sidebar-button'
        style={{ backgroundColor: mode === 'chat' ? '#FF8E04' : 'transparent' }}
      >
        <svg
          height='24'
          width='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7.50002 14.25H12.5M7.50002 10.75H16.5M21 12C21 16.9706 16.9706 21 12 21C11.2362 21 10.4946 20.9048 9.78639 20.7257C9.2398 20.5875 8.66929 20.5382 8.11857 20.6589L4.56789 21.4371C3.43334 21.6858 2.45879 20.6062 2.82193 19.5029L3.57095 17.2274C3.81962 16.4719 3.73499 15.6561 3.47856 14.9032C3.16832 13.9924 3.00002 13.0158 3.00002 12C3.00002 7.02944 7.02945 3 12 3C16.9706 3 21 7.02944 21 12Z'
            stroke='#FFFEFD'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
      <div
        onClick={handleSetMarket}
        className='sidebar-button'
        style={{
          backgroundColor: mode === 'market' ? '#FF8E04' : 'transparent',
        }}
      >
        <svg
          height='24'
          width='24'
          viewBox='0 0 24 24'
          id='meteor-icon-kit__regular-marketplace-stall'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
          <g
            id='SVGRepo_tracerCarrier'
            strokeLinecap='round'
            strokeLinejoin='round'
          ></g>
          <g id='SVGRepo_iconCarrier'>
            <g clipPath='url(#clip0_525_139)'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20 7H22.6743C23.3387 7 23.8183 6.36409 23.6358 5.72528L22.2072 0.725279C22.0846 0.295977 21.6922 0 21.2457 0H2.75431C2.30783 0 1.91545 0.295978 1.79279 0.725279L0.364219 5.72528C0.1817 6.3641 0.661363 7 1.32574 7H4V14H1C0.447715 14 0 14.4477 0 15C0 15.5523 0.447715 16 1 16H2V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V16H23C23.5523 16 24 15.5523 24 15C24 14.4477 23.5523 14 23 14H20V7ZM2.65147 5L3.50862 2H20.4914L21.3486 5H2.65147ZM18 7H6V14H18V7ZM20 16V22H18V16H20ZM16 22V16H13V22H16ZM11 16V22H8V16H11ZM6 22V16H4V22H6Z'
                fill='#FFFEFD'
              ></path>
            </g>
            <defs>
              <clipPath id='clip0_525_139'>
                <rect width='24' height='24' fill='white'></rect>
              </clipPath>
            </defs>
          </g>
        </svg>
      </div>

      <div
        onClick={handleSetPromo}
        className='sidebar-button'
        style={{
          backgroundColor: mode === 'promocodes' ? '#FF8E04' : 'transparent',
        }}
      >
        <svg
          height={40}
          width={40}
          fill='#ffffff'
          viewBox='0 0 512 512'
          enableBackground='new 0 0 512 512'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='SVGRepo_iconCarrier'>
            <g id='Layer_1'></g>
            <g id='Layer_2'>
              <g>
                <path d='M412.7,134.4H229.6c-2,0-3.9,0.8-5.3,2.2l-27.8,27.8L169.1,137c-1.4-1.4-3.3-2.2-5.3-2.2H99.3c-4.1,0-7.5,3.4-7.5,7.5 v227.4c0,4.1,3.4,7.5,7.5,7.5h64.5c2,0,3.9-0.8,5.3-2.2l27.4-27.4l27.8,27.8c1.4,1.4,3.3,2.2,5.3,2.2h183.1c4.1,0,7.5-3.4,7.5-7.5 V141.9C420.2,137.7,416.8,134.4,412.7,134.4z M405.2,362.6H232.7l-30.9-30.9c-2.9-2.9-7.7-2.9-10.6,0l-30.5,30.5h-53.9V149.8h53.9 l30.5,30.5c2.9,2.9,7.7,2.9,10.6,0l30.9-30.9h172.5V362.6z'></path>
                <path d='M276.9,235.2c15.4,0,28-12.6,28-28s-12.6-28-28-28s-28,12.6-28,28S261.4,235.2,276.9,235.2z M276.9,194.2 c7.2,0,13,5.8,13,13s-5.8,13-13,13s-13-5.8-13-13S269.7,194.2,276.9,194.2z'></path>
                <path d='M360,262.4c-15.4,0-28,12.6-28,28s12.6,28,28,28s28-12.6,28-28S375.4,262.4,360,262.4z M360,303.4c-7.2,0-13-5.8-13-13 s5.8-13,13-13s13,5.8,13,13S367.2,303.4,360,303.4z'></path>
                <path d='M256.6,310.7c1.5,1.5,3.4,2.2,5.3,2.2s3.8-0.7,5.3-2.2l113.1-113.1c2.9-2.9,2.9-7.7,0-10.6c-2.9-2.9-7.7-2.9-10.6,0 L256.6,300.1C253.6,303,253.6,307.7,256.6,310.7z'></path>
                <path d='M196.5,202.5c-2,0-3.9,0.8-5.3,2.2c-1.4,1.4-2.2,3.3-2.2,5.3c0,2,0.8,3.9,2.2,5.3c1.4,1.4,3.3,2.2,5.3,2.2 c2,0,3.9-0.8,5.3-2.2c1.4-1.4,2.2-3.3,2.2-5.3c0-2-0.8-3.9-2.2-5.3C200.4,203.3,198.4,202.5,196.5,202.5z'></path>
                <path d='M196.5,233.2c-2,0-3.9,0.8-5.3,2.2c-1.4,1.4-2.2,3.3-2.2,5.3c0,2,0.8,3.9,2.2,5.3c1.4,1.4,3.3,2.2,5.3,2.2 c2,0,3.9-0.8,5.3-2.2c1.4-1.4,2.2-3.3,2.2-5.3c0-2-0.8-3.9-2.2-5.3C200.4,234,198.4,233.2,196.5,233.2z'></path>
                <path d='M196.5,263.8c-2,0-3.9,0.8-5.3,2.2c-1.4,1.4-2.2,3.3-2.2,5.3c0,2,0.8,3.9,2.2,5.3c1.4,1.4,3.3,2.2,5.3,2.2 c2,0,3.9-0.8,5.3-2.2c1.4-1.4,2.2-3.3,2.2-5.3c0-2-0.8-3.9-2.2-5.3C200.4,264.6,198.4,263.8,196.5,263.8z'></path>
                <path d='M196.5,294.5c-2,0-3.9,0.8-5.3,2.2c-1.4,1.4-2.2,3.3-2.2,5.3c0,2,0.8,3.9,2.2,5.3c1.4,1.4,3.3,2.2,5.3,2.2 c2,0,3.9-0.8,5.3-2.2c1.4-1.4,2.2-3.3,2.2-5.3c0-2-0.8-3.9-2.2-5.3C200.4,295.3,198.4,294.5,196.5,294.5z'></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div
        onClick={handleSetDelivery}
        className='sidebar-button'
        style={{
          backgroundColor: mode === 'delivery' ? '#FF8E04' : 'transparent',
        }}
      >
        <svg
          fill='#ffffff'
          version='1.1'
          id='Capa_1'
          xmlns='http://www.w3.org/2000/svg'
          width='24px'
          height='24px'
          viewBox='0 0 612 612'
          stroke='#ffffff'
        >
          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
          <g
            id='SVGRepo_tracerCarrier'
            strokeLinecap='round'
            strokeLinejoin='round'
          ></g>
          <g id='SVGRepo_iconCarrier'>
            <g>
              <path d='M369.847,273.601l34.898-47.489c3.338-4.543,11.588-3.76,14.851,1.336l31.713,49.546 c3.039,4.747-0.762,10.407-6.907,10.218l-13.246-0.408v88.849c0,3.92-3.708,7.346-8.322,7.653l-21.436,1.429 c-4.861,0.324-8.836-2.715-8.836-6.789v-92.331l-14.71-0.455C370.742,284.939,366.25,278.495,369.847,273.601z M499.32,288.904 l11.485,0.354v81.659c0,3.604,3.11,6.317,6.919,6.064l16.842-1.123c3.636-0.241,6.561-3.26,6.561-6.742v-78.923l10.47,0.323 c4.866,0.149,7.88-4.903,5.47-9.118l-25.047-43.824c-2.566-4.49-9.049-5.105-11.667-1.05l-27.264,42.209 C490.288,283.066,493.783,288.734,499.32,288.904z M353.697,425.462l212.051-21.628c1.695-0.173,3.063-1.68,3.063-3.365v-9.16 c0-1.686-1.368-2.938-3.063-2.795l-212.051,17.806c-2.658,0.223-4.823,2.126-4.823,4.251v11.538 C348.874,424.232,351.039,425.734,353.697,425.462z M612,149.682v358.51c0,21.728-15.857,40.204-37.334,43.501l-261.99,40.206 c-4.425,0.679-8.926,0.679-13.351,0l-133.945-20.557V431.671l-47.729,9.396v122.95L37.333,551.69 C15.857,548.396,0,529.919,0,508.191v-358.51c0-19.013,12.209-35.875,30.272-41.811l87.378-28.709v107.281l47.729-9.396V63.48 l126.883-41.688c8.923-2.932,18.551-2.932,27.475,0l261.991,86.079C599.791,113.807,612,130.669,612,149.682z M578.992,141.716 L339.008,62.867v491.597l239.985-36.83L578.992,141.716L578.992,141.716z'></path>
            </g>
          </g>
        </svg>
      </div>
      <div
        className='sidebar-button'
        style={{
          backgroundColor: mode === 'settings' ? '#FF8E04' : 'transparent',
        }}
        onClick={handleSetSettings}
      >
        <svg
          fill='#ffffff'
          height='24px'
          width='24px'
          version='1.1'
          id='Capa_1'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 54 54'
        >
          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
          <g
            id='SVGRepo_tracerCarrier'
            strokeLinecap='round'
            strokeLinejoin='round'
          ></g>
          <g id='SVGRepo_iconCarrier'>
            <g>
              <path
                d='M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,
              0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.42l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z'
              ></path>
              <path d='M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z'></path>{' '}
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default Sidebar;
